import React, { useState, useEffect } from 'react';
import axios from 'axios';
import WebService from '../../../services/webservice';

export const AdminMenuList = [
    //Dashboard
    {
        classsChange: 'mm-collapse',
        iconStyle: <i className="fa fa-tachometer-alt" />, // Dashboard icon
        title: 'Dashboard',
        to: '/dashboard',
    },
    {
        classsChange: 'mm-collapse',
        iconStyle: <i className="fa fa-clipboard-list" />, // Audit Log icon
        title: 'User Management',
        to: '/Users',
    },
    {
        classsChange: 'mm-collapse',
        iconStyle: <i className="fa fa-bell" />, // Notification icon
        title: 'Notifications',
        to: '/notification',
    },
    {
        title: 'Period Tracking',
        to: '/period-tracking-dashboard',
        iconStyle: <i className="fa-solid fa-calendar-plus" />,
        classsChange: 'mm-collapse',
    },
    // Pregnancy Tracking
    {
        title: 'Pregnancy Tracking',
        to: '/pregnancy-tracking',
        iconStyle: <i className="fa-solid fa-female" />,
        classsChange: 'mm-collapse',
    },
    {
        classsChange: 'mm-collapse',    
        iconStyle: <i className="fa-solid fa-music" />, // Audit Log icon
        title: 'Music Management',
        to: '/music-listing',
    },
    {
        title: 'Vitals',
        to: '/vitals',
        iconStyle: <i className="fa-solid fa-heartbeat" />,
        classsChange: 'mm-collapse',
    },
    {
        title: 'Profile Questions',
        to: '/profile-questions',
        iconStyle: <i className="fa fa-question-circle" />,
    },
    {
        title: 'Masters',
        to: 'master-analytics',
        iconStyle: <i className="fa-solid fa-chart-line" />,
        content: [
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-droplet"></i>,
                title: 'Period Article',
                to: '/OverAllPeriodTracking',
            },
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-apple-whole"></i>,
                title: 'Fruits List',
                to: '/fruits',
            },
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-pepper-hot"></i>,
                title: 'Vegetables List',
                to: '/vegetables',
            },
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-bread-slice"></i>,
                title: 'Grains List',
                to: '/grains',
            },
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-microscope"></i>,
                title: 'Medical Checkup List',
                to: '/med_list',
            },
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-kit-medical"></i>,
                title: 'First Aid',
                to: '/first-aid',
            },
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-syringe"></i>,
                title: 'Vaccination',
                to: '/vaccination',
            },
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-triangle-exclamation"></i>,
                title: 'Symptom',
                to: '/symptoms',
            },
        ]
    },
    {
        title: 'Audit Log',
        to: 'audit-log',
        iconStyle: <i className="fa-solid fa-chart-column" />,
        content: [
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa fa-robot" />,
                title: 'AI Audit',
                to: '/ai-insights',
            },
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa fa-user" />,
                title: 'MicroService Audit',
                to: '/microservice-feature',
            },
             {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-list-check" />, // Audit Log icon
                title: 'Screen Audit',
                to: '/screen-auditlog',
            },
            {
                title: "API Audit",
                to: '/api-analytics',
                iconStyle: <i className="fa-solid fa-rocket" />,
                classsChange: 'mm-collapse',
            },
        ] } , 
    
        {
        title: 'Configurations',
        to: 'configurations',
        iconStyle: <i className="fa-solid fa-sliders" />,
        content: [
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-list" />,
                title: "App Menu",
                to: '/app-menu',
            },
             {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-user" />,
                title: 'Admin Creation',
                to: '/admin-creation',
            }, 
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-users-gear" />,
                title: 'Role Management',
                to: '/role-management',
            },
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa fa-cogs" />,
                title: 'Remote Config',
                to: '/configure',
            },
            {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-server" />,
                title: 'System Config',
                to: '/system-config',
            },
              {
                classsChange: 'mm-collapse',
                iconStyle: <i className="fa-solid fa-arrow-up-from-bracket" />, // App Update icon
                title: 'App Update',
                to: '/app-update',
            },
        ] } , 
      ];

export const useFilteredMenus = () => {
    const [menuList, setMenuList] = useState([]);
    
    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const usertype = localStorage.getItem('usertype');
                let isSuperAdmin = (usertype === 'Super Admin');

                if (isSuperAdmin) {
                    setMenuList(AdminMenuList);
                    return;
                }

                const rolesRes = await axios.get(`${WebService}api/role-list`);
                const roles = rolesRes.data.success ? rolesRes.data.data : [];
                const userRole = roles.find(r => r.roleName === usertype);
                
                let allowedMenuNames = [];
                if (userRole && userRole.screenPermissions) {
                    allowedMenuNames = userRole.screenPermissions.map(p => p.menuName);
                }
                
                // Filter AdminMenuList based on allowedMenuNames
                const filtered = AdminMenuList.map(menu => {
                    // If it has children, filter the children
                    if (menu.content) {
                        const filteredChildren = menu.content.filter(child => allowedMenuNames.includes(child.title));
                        if (allowedMenuNames.includes(menu.title) || filteredChildren.length > 0) {
                            return { ...menu, content: filteredChildren };
                        }
                        return null;
                    }
                    
                    // If no children, check if it's allowed
                    if (allowedMenuNames.includes(menu.title)) {
                        return menu;
                    }
                    return null;
                }).filter(Boolean); // Remove nulls
                
                setMenuList(filtered);
            } catch (error) {
                console.error("Error filtering dynamic menus", error);
                // Fallback to static list if error
                setMenuList(AdminMenuList);
            }
        };
        fetchPermissions();
    }, []);
    return menuList;
};

